import type { NextPage, GetServerSideProps } from 'next'

import { ProjectModel } from '@/modules/project'
import type { Item, Pagination } from '@/modules/project'

import SEO from '@/modules/seo'
import Page from '@/components/pages/opinion/participation/items'


export const getServerSideProps: GetServerSideProps = async (context) => {
  const page = parseInt(context.query.page as string, 10) || 1
  const limit = parseInt(context.query.limit as string, 10) || 10
  const query = encodeURIComponent(context.query.query as string || '')
  const type = context.query.type as string || ''
  const state = undefined;
  const step = 'preparation_form';

  const model = new ProjectModel();
  const result = await model.getItems({ query, state, type, step, page, limit });

  return {
    props: {
      items: result.items,
      pagination: result.pagination
    }
  }
}

interface IProps {
  items: Item[] | []
  pagination: Pagination
}

const Component: NextPage<IProps> = (props) => {
  const pageTitle = `주민의견 제출`

  return (
    <div className='flex flex-col justify-center'>
      <SEO title={pageTitle} />
      <Page {...props} />
    </div>
  )
}

export default Component
